// src/components/BackNavigation/BackNavigation.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';

function BackNavigation({ backLink = '/', iconSrc = '/images/icon/icon_arrow_left.svg' }) {
  const { t } = useTranslation();
  const location = useLocation();

  // 明示的に lang, qr を取得
  const searchParams = new URLSearchParams(location.search);
  const currentLang = searchParams.get('lang') || 'ja';
  const currentQr = searchParams.get('qr') || '';

  const search = `?qr=${currentQr}&lang=${currentLang}`;

  return (
    <nav className="back-nav box-nav">
      <Link to={{ pathname: backLink, search }} className="back-link">
        <span className="icon icon-arrow-left">
          <img src={iconSrc} alt={t('backNavigation.label')} width="15" height="15" />
        </span>
        <span>{t('backNavigation.label')}</span>
      </Link>
    </nav>
  );
}

export default BackNavigation;
